import { Checkbox, FormControlLabel, IconButton, Popover, TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles, Theme } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import FilterListIcon from '@material-ui/icons/FilterList';
import { Observer, observer } from 'mobx-react';
import React from 'react';
import { IBrand, IEntityStore } from '../../../main/entities';
import { transl } from '../../../main/transl';
import { IEntityStateAgg } from '../../../main/useEntityStateAgg';
import { useDoubleClick } from '../../../mg/useDoubleClick';
import { IBooleanStateAgg, useBooleanStateAgg } from '../../../mg/useStateAgg';
import { EditBrandDialog } from './EditBrandDialog';

const useStyles = makeStyles((theme: Theme) => ({
	harmoBrandFilter: {
		display: 'flex',
		marginLeft:'15px',
		marginRight: '5px'
	},
	popper: {
		'& .MuiPopover-paper': {
			minWidth: '40%',
			minHeight: 200,
			padding: '20px 30px 40px',
			display: 'grid',
			gap: '10px',
		},
		'& .MuiPopover-paper > *': {
		},
	},
	filterOn: {
		color: theme.palette.secondary.main,
	},
	row: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		gap: '10px',
	},
	transparent: {
		opacity: 0,
	},
}));

interface IHarmoBrandFilterProps {
	showNonMastersOnlyAgg: IBooleanStateAgg
	ignoreBrandAgg: IBooleanStateAgg
	brandAgg: IEntityStateAgg<IBrand, IEntityStore<IBrand>>
}

export const HarmoBrandFilter = observer(function(props: IHarmoBrandFilterProps ) {
	const { showNonMastersOnlyAgg, ignoreBrandAgg, brandAgg } = props;
	const classes = useStyles();
	const [anchorEl, setAnchorEl] = React.useState<EventTarget&Element|null>(null);

	const handleClick = useDoubleClick(
		(e: React.MouseEvent) => {
			setAnchorEl(e.currentTarget);
		},
		(e: React.MouseEvent) => {
			setAnchorEl(null);
			ignoreBrandAgg.toggleHandler();
		});

	const brandId = (brandAgg.repo.byId(brandAgg.id) ? brandAgg.id : '') || '';
	const editBrandDialogOpenAgg = useBooleanStateAgg();
	function closeEditBrandDialog() {
		editBrandDialogOpenAgg.falseHandler();
		setAnchorEl(null);
	}

	return <Observer>{() =>
		<div className={classes.harmoBrandFilter}>
			<div>
				<IconButton onClick={handleClick} className={ignoreBrandAgg.value ? '' : classes.filterOn}>
					<FilterListIcon/>
				</IconButton>
				<Popover
					open={!!anchorEl}
					onClose={() => setAnchorEl(null)}
					anchorEl={anchorEl}
					className={classes.popper}
					anchorOrigin={{vertical: 'center', horizontal: 'left'}}
					transformOrigin={{vertical: 'center', horizontal: 'right'}}
				>
					<h2>{transl('filterOnBrand')}</h2>
					<FormControlLabel
						control={<Checkbox color={'primary'} checked={showNonMastersOnlyAgg.value} onClick={showNonMastersOnlyAgg.toggleHandler}/>}
						label={transl('showNonMastersOnly')}
					/>
					<FormControlLabel
						className={brandId ? '' : classes.transparent}
						control={<Checkbox color={'primary'} checked={ignoreBrandAgg.value} onClick={ignoreBrandAgg.toggleHandler}/>}
						label={transl('ignoreBrand')}
					/>
					<div className={classes.row}>
						<TextField select
							label={transl('selectBrand')}
							value={brandId}
							onChange={e => {brandAgg.changeHandler(e); ignoreBrandAgg.falseHandler(e);}}
						>
							{brandAgg.repo.allAsList.map(x => <MenuItem value={x.id} key={x.id}>{x.name}</MenuItem>)}
						</TextField>
						<IconButton onClick={editBrandDialogOpenAgg.trueHandler} disabled={!brandAgg.value}>
							<EditIcon/>
						</IconButton>
					</div>
				</Popover>
			</div>
			{!editBrandDialogOpenAgg.value || !brandAgg.value ? null : <EditBrandDialog brand={brandAgg.value} onClose={closeEditBrandDialog}/>}
		</div>
	}</Observer>;
});
